import axiosInstance from "./axiosinstance";

export interface AdminDashboardResponse {
  customers: {
    total: number;
    withAmc: number;
    withoutAmc: number;
    expiringAmcWithinMonth: number;
  };
  serviceCalls: {
    total: number;
    open: number;
    closed: number;
    inProgress: number;
  };
  quotations: {
    total: number;
  };
}

export const dashboardRepository = {
  async getAdminDashboard(): Promise<AdminDashboardResponse> {
    const response = await axiosInstance.get<AdminDashboardResponse>(
      "/api/dashboard/admin"
    );
    return response.data;
  },
};

export default dashboardRepository;